import React, { useEffect, useState } from 'react';
import Icon from '../../basic/icons';
import useFavorite from './hooks/useFavorite';
import FavoriteConfirmModal from '../modals/favorite';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import GeneralOperationErrorModal from '../../../common/generalOperationalErrorModal';
import { buildAnalyticsLocations } from '../../basic/quickLink';
import {
  DataAnalyticsClicksFavorites,
  DataAnalyticsLocations,
  DataAnalyticsTypes,
} from '../../basic/analytics';
import useSplunkLogger from '../../../common/hooks/useSplunkLogger';
import { useUserProfile } from '../../../providers/user-provider';
import { InternalLinks } from '../../../common/enums/common';
import { useRouter } from '../../../common/hooks/useRouter';

export default function ProductFavorite({
  onFavoriteItemClick,
  skuid,
}: Readonly<{
  onFavoriteItemClick: (selItem: string, isSelected: boolean) => void;
  skuid: string;
}>): JSX.Element {
  const { handleFavorite, isFavoriteSelected, error } = useFavorite();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const favSelected = isFavoriteSelected(skuid);
  const { t } = useTranslation();
  const [showErrorModal, setShowErrorModal] = useState(false);
  const { userProfile } = useUserProfile() || {};
  const isLoggedIn = !!userProfile;
  const { navigate } = useRouter();

  useEffect(() => {
    if (error && error.message !== '') {
      setShowErrorModal(true);
    } else {
      setShowErrorModal(false);
    }
  }, [error]);

  const handleFavoriteClick = (sku: string) => {
    if(isLoggedIn) {
      handleFavorite(favSelected, sku);
      onFavoriteItemClick(sku, favSelected);
    } else {
      const pathParts = window.location.pathname.split('/').filter(Boolean);
      const originalPath = '/' + pathParts.slice(1).join('/') + window.location.search;
      navigate(`${InternalLinks.addFavorite}?SKU=${sku}&originalPath=${originalPath}`);
    }
  };
  const checkFavoriteModal = (evt: React.SyntheticEvent<HTMLButtonElement>, sku: string) => {
    console.log('sku is not coming for favorites', sku);
    evt.stopPropagation();
      if (!sku) {
      console.log('sku is not coming for favorites');
      return false;
    }
    if (favSelected) {
      setIsDialogOpen(true);
    } else {
      handleFavoriteClick(sku);
    }
  };
  const {splunkLogger} = useSplunkLogger()

  const dataAnalyticsLocation = buildAnalyticsLocations([
    DataAnalyticsLocations.Page,
    DataAnalyticsLocations.Body,
    DataAnalyticsLocations.Grid,
    DataAnalyticsLocations.Card,
  ],splunkLogger);
  return (
    <>
      <FavoriteConfirmModal
        isOpen={isDialogOpen}
        handleClose={() => {
          setIsDialogOpen(prev => !prev);
        }}
        onSelected={() => {
          handleFavoriteClick(skuid);
          setIsDialogOpen(false);
        }}
      />

      {error && error.message !== '' && (
        <GeneralOperationErrorModal
          isOpen={showErrorModal}
          handleClose={() => setShowErrorModal(false)}
          errorMessage={error.message}
        />
      )}

      <button
        type="button"
        data-testid="product-favorite"
        aria-pressed={favSelected}
        aria-label={
          favSelected ? t('aria.label.favorite.selected') : t('aria.label.favorite.unselected')
        }
        className="group cursor-pointer text-secondary-400 z-20 w-6 h-6 lg:w-11 lg:h-11 relative"
        data-analytics-type={DataAnalyticsTypes.Media}
        data-analytics-click={DataAnalyticsClicksFavorites.ADD_EYEGLASS_FRAME_FAVORITE}
        data-analytics-location={dataAnalyticsLocation}
        onClick={evt => checkFavoriteModal(evt, skuid)}
      >
        <span className='sr-only'>Favorite</span>
        <Icon
          name={favSelected ? 'favoritesFull' : 'heart'}
          title="Favorite"
          className="text-secondary-400 font-extrabold text-xl xl:text-2xl mt-1 absolute right-0"
        />
        {/* <QuickLink
          data-testid="Favorite Icon"
          dataAnalytics={buildAnalytics(
            DataAnalyticsLocations.Tile,
            DataAnalyticsTypes.Media,
            [
              DataAnalyticsLocations.Grid
            ],
            favSelected ? DataAnalyticsClicks.DELETE_EYEGLASS_FRAME_FAVORITE : DataAnalyticsClicks.ADD_EYEGLASS_FRAME_FAVORITE)}
          href='#'>
            <Icon
              name={favSelected ? 'favoritesFull' : 'heart'}
              className="text-[18px] mt-1 mr-1 md:text-[26px] md:mt-2xs md:mr-[8px]"
            />
        </QuickLink>*/}
      </button>
    </>
  );
}
